/**
 * Lightweight audit context for enriching backend audit logs.
 *
 * Usage in components:
 *   import { setAuditContext } from '../utils/audit-context';
 *
 *   // Before an API call, declare what triggered it:
 *   setAuditContext({ component: 'GoalDetail', action: 'approve-goal' });
 *   await goalsApi.update(id, { status: 'approved' });
 *
 * The axios interceptor (api.ts) reads these values and attaches them
 * as X-Audit-Component / X-Audit-Action headers. After each request
 * the values auto-clear so they don't leak into unrelated calls.
 */

let _component = '';
let _action = '';

/** Set audit context before triggering an API call. */
export function setAuditContext(ctx: { component?: string; action?: string }) {
  _component = ctx.component ?? '';
  _action = ctx.action ?? '';
}

/** Read and clear the current context (called by the axios interceptor). */
export function consumeAuditContext(): { component: string; action: string } {
  const result = { component: _component, action: _action };
  _component = '';
  _action = '';
  return result;
}
